import { render, staticRenderFns } from "./LdTagContainer.vue?vue&type=template&id=3255b69f"
import script from "./LdTagContainer.vue?vue&type=script&lang=js"
export * from "./LdTagContainer.vue?vue&type=script&lang=js"
import style0 from "./LdTagContainer.vue?vue&type=style&index=0&id=3255b69f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports